import {PWMAT_RESOURCE} from './consts'

export const Train = [{
  name:'1. PWmat Basic Training 1',
  url:'https://www.bilibili.com/video/BV1uY4y1v7h8?p=1',
  file_name:' How to learn PWmat'
},
{
  name:'2. PWmat Basic Training 2',
  url:'https://www.bilibili.com/video/BV1uY4y1v7h8?p=2',
  file_name:' self-consistency, energy band, and state density calculation'
},
{
  name:'3. PWmat Basic Training 3',
  url:'https://www.bilibili.com/video/BV1uY4y1v7h8?p=3',
  file_name:' structure optimization and molecular dynamics calculation'
},
{
  name:'4. PWmat Basic Training 4',
  url:'https://www.bilibili.com/video/BV1uY4y1v7h8?p=4',
  file_name:' Time-dependent density functional TDDFT calculation'
},
{
  name:'5. PWmat Basic Training 5',
  url:'https://www.bilibili.com/video/BV1uY4y1v7h8?p=5',
  file_name:' Non-adiabatic Molecular Dynamics NAMD Calculation'
},
{
  name:'6. Mcloud Tutorial',
  url:'https://www.bilibili.com/video/BV1BP4y127Jn/?spm_id_from=333.999.0.0',
  file_name:' Mcloud Usage Guide'
},
{
  name:'7. Q-Studio Modeling Tutorial 1',
  url:'https://www.bilibili.com/video/BV1B8411b7Ci/?spm_id_from=333.999.0.0',
  file_name:' Volume Material and Surface Structure Modeling'
},
{
  name:'8. Q-Studio Modeling Tutorial 2',
  url:'https://www.bilibili.com/video/BV1Pe4y147Di/?spm_id_from=333.999.0.0',
  file_name:' 2D Material and Moiré Fringe Modeling'
},
{
  name:'9. Q-Studio Modeling Tutorial 3',
  url:'https://www.bilibili.com/video/BV1TG4y1t7vy/?spm_id_from=333.999.0.0',
  file_name:' Heterojunction Modeling'
},
{
  name:'10. Q-Flow Tutorial 1',
  url:'https://www.bilibili.com/video/BV1ke4y1a74i/?spm_id_from=333.999.0.0',
  file_name:' Structural Optimization'
},
{
  name:'11. Q-Flow Tutorial 2',
  url:'https://www.bilibili.com/video/BV1Nt4y1T798/?spm_id_from=333.999.0.0',
  file_name:' PBE and HSE Band Calculation'
},
{
  name:'12. Q-Flow Tutorial 3',
  url:'https://www.bilibili.com/video/BV1qe4y1a7WM/?spm_id_from=333.999.0.0',
  file_name:' PBE and HSE Density of State Calculation'
},
{
  name:'13. Q-Flow Tutorial 4',
  url:'https://www.bilibili.com/video/BV1bd4y1k7zp/?spm_id_from=333.999.0.0',
  file_name:' DFT+U Calculation'
},
{
  name:'14. Q-Flow Tutorial 5',
  url:'https://www.bilibili.com/video/BV1jd4y1k7JA/?spm_id_from=333.999.0.0',
  file_name:' Calculation of Optical Properties of Bulk and Two-Dimensional Materials'
},
{
  name:'15. Q-Flow Tutorial 6',
  url:'https://www.bilibili.com/video/BV1UW4y177L3/?spm_id_from=333.999.0.0',
  file_name:' OER Calculation with Implicit Solvent Effects'
},
{
  name:'16. Q-Flow Tutorial 7',
  url:'https://www.bilibili.com/video/BV1tg41187Nx/?spm_id_from=333.999.0.0',
  file_name:' Calculation of OER by Fixed Potential Method'
},
{
  name:'17. Q-Flow Tutorial 8',
  url:'https://www.bilibili.com/video/BV1cW4y1T7QP/?spm_id_from=333.999.0.0',
  file_name:' NEB Calculation of Transition States'
},
]
